const palette = {
  carvanaBlue: '#00aed9', // Links, Primary Buttons, Icons
  carvanaBlueHover: '#018dc0',
  carvanaYellow: '#feb948', // Secondary Buttons, Attention Icons
  carvanaYellowHover: '#eb9f23',
  darkBlue1: '#183558', // Header/Footer Backgrounds, Headlines, Text
  darkBlueStroke: '#122946',
  darkBlue2: '#00619e', // Sticky Header Background
  darkGray1: '#757989', // Text, Icons
  darkGray2: '#aab1c7', // Favorite Heart Unselected, Icons
  midGray: '#d9dde9', // Tab/Field Outlines, Lines
  backgroundGray: '#f4f8fa', // Background areas
  green: '#1dd08b', // Success Icons
  red: '#ff7171', // Alerts, Favorited Heart Selected
  lightBlue: '#cfeaf2', // Accent Color
  lightYellow: '#fbf2de', // Accent Color
  white: '#ffffff'
};

export default palette;
